import React, { useEffect, useState } from 'react';
import { Modal, Fade, Typography, Box, Backdrop, Button, IconButton, styled, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Paper from '@mui/material/Paper';
import { API, graphqlOperation } from 'aws-amplify';
import { deleteAccountGroupMaster } from '../../graphql';
import { showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { Add, ArrowRight } from '@mui/icons-material';
import { SimpleTreeView } from '@mui/x-tree-view';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import ViewRecursiveListItem from './ViewRecursiveListItem';
import NewAddPartyGroup from './newAddPartyGroup';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  // p: 4,
  outline: 'none',
};

const CustomExpandIcon = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.primary.main, // Customize color
  fontSize: '25px !important', // Customize size
}));
const CustomCollapseIcon = styled(ArrowDropDownIcon)(({ theme }) => ({
  color: theme.palette.primary.main, // Customize color
  fontSize: '25px !important', // Customize size
}));

const NewViewPartyGroups = ({ open, setOpen, defaultGroup, setData, data, setNewGp, partyGroups, loc, getAccountData }) => {
  const [editModal, setEditModal] = useState();
  const [editData, setEditData] = useState();
  const [backdropOpen, setBackdropOpen] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
      getAccountData();
    }
  };
  const deleteGroup = async (value) => {
    setBackdropOpen(true);
    try {
      const res = await API.graphql(
        graphqlOperation(deleteAccountGroupMaster, {
          accountgroupid: Number(value),
        })
      );
      if (res?.data?.deleteAccountGroupMaster?.statuscode == 'Success') {
        showSuccessSnackbar(res?.data?.deleteAccountGroupMaster?.statusmessage);
        const datadd = removeNodeByValue(data, value);
        setData(datadd);
        setNewGp(defaultGroup);
      } else {
        showWarningSnackbar(res?.data?.deleteAccountGroupMaster?.statusmessage);
      }
    } catch (error) {
      console.log(error);
      const rawMessage = error?.errors[0]?.message?.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage)?.message;
      const errorMessage = parsedMessage?.split('ERROR: ')[1]?.split(';')[0];
      showWarningSnackbar(errorMessage);
    }
    setBackdropOpen(false);
  };
  const removeNodeByValue = (nodes, targetValue) => {
    return nodes
      .filter((node) => node.value != targetValue) // Remove the current node if its value matches
      .map((node) => {
        if (node.children && node.children.length > 0) {
          return {
            ...node,
            children: removeNodeByValue(node.children, targetValue),
          }; // Recurse into children
        }
        return node; // Return the node as is if no children
      });
  };

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);

  return (
    <Modal
      id={open ? 'listPartyGroup' : ''}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Paper
          sx={{
            ...style,
            width: { sm: '85%', md: '500px' },
          }}
        >
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '5px 15px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                {loc == true ? 'Customer ' : 'Supplier '} Groups
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            className="custom-scrollbar"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              // width: { sm: "75%", md: '450px' },
              height: '400px',
              padding: '15px',
              overflowX: 'hidden',
            }}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{
                justifyContent: 'space-between',
                color: '#595C66',
                borderTopRightRadius: 4,
                borderTopLeftRadius: 4,
                p: 1,
                backgroundColor: 'background.tablebg',
                display: 'flex',
              }}
              gutterBottom
            >
              <Box style={{ display: 'flex' }}>
                <Typography sx={{ fontWeight: 'bold' }} align="left">
                  Group
                </Typography>
                <Button
                  sx={{
                    whiteSpace: 'nowrap',
                    border: '1px solid white',
                    m: { xs: '0px 10px', sm: '0 6px', md: '0 10px' },
                    fontWeight: 'bold',
                    backgroundColor: 'white',
                    padding: '2px 5px',
                    fontSize: '12px',
                    '&:hover': {
                      backgroundColor: 'white', // Override hover background color
                    },
                  }}
                  variant="outlined"
                  startIcon={<Add />}
                  onClick={() => setEditModal(true)}
                >
                  Add Group
                </Button>
              </Box>

              <Typography sx={{ fontWeight: 'bold' }} align="left">
                Actions
              </Typography>
            </Typography>
            <SimpleTreeView
              aria-label="customized"
              defaultExpandedItems={partyGroups.map((g) => g.value)}
              slots={{
                expandIcon: CustomExpandIcon,
                collapseIcon: CustomCollapseIcon,
                // endIcon: CustomEndIcon,
              }}
              sx={{
                // overflowY: 'scroll', minHeight: 270,
                flexGrow: 1,
                width: '100%',
                fontWeight: 'bold',
              }}
            >
              {data?.map((item) => {
                return (
                  <ViewRecursiveListItem
                    loc={loc}
                    key={item.value}
                    item={item}
                    setEditData={setEditData}
                    deleteGroup={deleteGroup}
                    removeNodeByValue={removeNodeByValue}
                    rows={partyGroups}
                    data={data}
                    setEditModal={setEditModal}
                    setRows={setData}
                    setOpen={setOpen}
                    getAccountData={getAccountData}
                  />
                );
              })}
            </SimpleTreeView>
          </Box>
          {editModal && (
            <NewAddPartyGroup
              open={editModal}
              setOpen={setEditModal}
              setNewGp={setNewGp}
              viewOpen={setOpen}
              options={partyGroups}
              getAccountData={getAccountData}
              editData={editData}
              setEditData={setEditData}
            />
          )}
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default NewViewPartyGroups;
